import { gaPanelConfig } from "../shared/helper";

export const changeColor = (callback:any) => {
    const handleScroll = () => {
      if (window.scrollY >= 110) {
        callback(true);
      } else {
        callback(false);
      }
    };
  
    window.addEventListener('scroll', handleScroll);
  
    // Cleanup function to remove the event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  };

 export function clearEvents() {
    gaPanelConfig.select_item = "";
    gaPanelConfig.select_result = "";
    gaPanelConfig.search_term = "";
    gaPanelConfig.AppName = "";
    gaPanelConfig.AppStatus = "";
    gaPanelConfig.AppSlug="";
    gaPanelConfig.BtnText="";
    gaPanelConfig.CardSection="";
   
 
    gaPanelConfig.blog_url=""
  
  }